import { HostListener, Component, OnInit } from '@angular/core';
import {Router,ActivatedRoute} from "@angular/router" ;
import { CategoryFilter } from '../../products/models/category-filter.model';
import { CategoryService } from '../../products/services/category.service';
import { Item } from '../../products/models/Products.model';
import { NgForm } from '@angular/forms';
import { Header } from '../../home/models/header.model';
import * as $ from 'jquery';
import { AuthService } from '../../authentication/services/auth.service';
import { Globals } from 'src/app/shared/global/globals';

@Component({
  selector: 'app-search-result',
  templateUrl: './search-result.component.html',
  styleUrls: ['./search-result.component.scss']
})
export class SearchResultComponent implements OnInit {
public searchValue;
public endPrice;
public sortBy;
public filterBy;
public siderImages: Header[];
public sliderOptions: any;
public searchresult;
public categoryIdOfRelatedProduct;
Arr = Array;
scroll:any;
numberOfPages:number = 0;
itemsList: Item[];
relatedProduct: Item[];
totalCount: number = 0;
endScroll :number =10;
endScroll2 :number =20;
startScroll :number =0;
categoryFilter: CategoryFilter = new CategoryFilter();
public loading = false;
invert = false;
max = null;
min = 0;
step = 1;
thumbLabel = false;
value = 0;
maxPrice:number;
latestDate = null ;
public translation;
public currentLang;
public txtDir ='ltr';
formatLabel(value: number) {
  if (value >= 1000) {
    return Math.round(value / 1000) + 'k';
  }
  this.value = value;
  return value;
}
/////////////////////////////////////////////////////////////////
  constructor(public globalVariables:Globals,private authService: AuthService,private _categoryService: CategoryService,private router: Router,private activatedRoute: ActivatedRoute) {  
    this.endScroll = 10;
    this.startScroll = 0;
    let lang = this.authService.getSelectedLang();
    this.translation = this.globalVariables.englishTranslation;
    if(lang != null){
      this.currentLang = lang;
      if(lang == 'Arabic'){
        this.txtDir='rtl';
        this.translation =  this.globalVariables.arabicTranslation;
      }else{
        this.txtDir='ltr';
        this.translation =  this.globalVariables.englishTranslation;
      }
    }else{
      this.currentLang = 'English';
      this.translation =  this.globalVariables.englishTranslation;
      this.txtDir='ltr';
    }
  }
/////////////////////////////////////////////////////////////////
  ngOnInit(): void {
    this.sortBy = 0;// no sort selected ...
    this.filterBy = false;
    this.endPrice = null;
    this.siderImages = this.getDummyData();
    this.sliderOptions = {
      items: 1,
      rtl: ($('html').css('direction') === 'rtl') ? true : false,
      margin: 10,
      autoplay: true,
      dots: false
    }
    this.activatedRoute.paramMap.subscribe(params => { 
       this.searchValue= params.get('searchValue'); 
       this.getMinMaxPrice(this.searchValue,null);
       this.siderImages = this.getDummyData();
       this.sliderOptions = {
         items: 1,
         rtl: ($('html').css('direction') === 'rtl') ? true : false,
         margin: 10,
         autoplay: true,
         dots: false
       }
  });
  this.getItemBySearch(this.startScroll,this.endScroll,this.searchValue);
  }
/////////////////////////////////////////////////////////////////
  sliderOnChange(maxPrice : number,latestDate){
    if(maxPrice == null){
      maxPrice = this.maxPrice;
    }else{
      this.maxPrice = maxPrice;
    }
    if(latestDate == null){
      latestDate = this.latestDate;
    }else{
      this.latestDate = latestDate;
    }
    this.loading = true;
    this.categoryFilter.Start =0;
    this.categoryFilter.End =10;
    this._categoryService.getAllItemsByMaxPriceAndLatestDate(this.categoryFilter,maxPrice,latestDate).subscribe(res => {
      this.loading = false;
      this.itemsList = res.ItemList;
      this.totalCount = res.TotalCount; 
      this.numberOfPages = Math.ceil(res.TotalCount/10);
    });
  }
/////////////////////////////////////////////////////////////////
getDummyData(): Header[] {
  return [
    { Id: 3, ImagePath: "images/2_bf8b8fd06e0ac00186a7bf9f5833447069b9e860d8a8c2c4197b78087f1159f7.png",title:"" }
  ]
}
/////////////////////////////////////////////////////////////////
  public getItemBySearch(startScroll,endScroll,searchValue) {
    this.loading = true;
    this.categoryFilter.Start = startScroll;
    this.categoryFilter.End = endScroll;
    this.categoryFilter.SearchValue = searchValue;
    this._categoryService.getAllItems(this.categoryFilter).subscribe(res => {
      this.loading = false;
      this.itemsList = res.ItemList;
      this.totalCount = res.TotalCount; 
      this.numberOfPages = Math.ceil(res.TotalCount/10);
      // for(let i of this.itemsList){
      //   this.categoryIdOfRelatedProduct = i.CategoryId;
      // }
      this.categoryFilter.Start = 0;
      this.categoryFilter.End = 3;
      // if(this.totalCount ==0){
      //   this.categoryFilter.CategorId = null;
      // }else{
      //   this.categoryFilter.CategorId = this.categoryIdOfRelatedProduct;
      // }
      // this._categoryService.getAllItemsByCategoryId(this.categoryFilter).subscribe(res=>{
      //   this.relatedProduct = res.ItemList;
      // });
    });
  }
/////////////////////////////////////////////////////////////////
  public getMinMaxPrice(searchValue,categoryId){
    this._categoryService.getMinMaxPrice(searchValue,categoryId).subscribe(res =>{
      this.max= res.MaxPrice;
    });
  }

/////////////////////////////////////////////////////////////////  
  @HostListener("window:scroll", ["$event"])
  onWindowScroll() {
  var scrollPosition = window.pageYOffset;
  var windowSize     = window.innerHeight;
  var bodyHeight     = document.body.offsetHeight;
  var  ScrollFromBottom = Math.max(bodyHeight - (scrollPosition + windowSize), 0);
  var total = Math.ceil(this.totalCount / 10) * 10;
    if(ScrollFromBottom < 400){
      if(this.endScroll <= total ){
          this.endScroll += 10 ;
          this.getItemBySearch(this.startScroll,this.endScroll,this.searchValue);
        }
      }
  }
/////////////////////////////////////////////////////////////////
SortBy(sortBy:any){
  this.sortBy = sortBy;
  if(this.sortBy != 0){
    if(this.sortBy == 1){//Price  Low To Hight ...
      this.categoryFilter.Orderby = "ItemPrice";
      this.categoryFilter.Dir = "ASC";
    }else if(this.sortBy == 2){//Price Hight To Low ...
      this.categoryFilter.Dir = "DESC";
    }else if(this.sortBy == 3){//Most Receent...
      this.categoryFilter.Orderby = "CreationTime";
      this.categoryFilter.Dir = "DESC";
    }else if(this.sortBy == 4){
      this.categoryFilter.Orderby = "mostordered";
    }
    this._categoryService.Filter(this.categoryFilter,0,this.endPrice,false).subscribe(res => {
      this.itemsList = res.ItemList;
      }
    );
  }
  
}
/////////////////////////////////////////////////////////////////
FilterBy(filterBy:any){
if(filterBy == 1){
  this.filterBy = true;
}else{
  this.filterBy = false;
}
this._categoryService.Filter(this.categoryFilter,0,this.endPrice,this.filterBy).subscribe(res => {
  this.itemsList = res.ItemList;
  }
);
}
/////////////////////////////////////////////////////////////////
updateEndPrice(event) {
this.endPrice = event.value;
this._categoryService.Filter(this.categoryFilter,0,this.endPrice,false).subscribe(res => {
  this.itemsList = res.ItemList;
  }
);
}
/////////////////////////////////////////////////////////////////
  onSubmit(f: NgForm) {
  }
/////////////////////////////////////////////////////////////////
}
